import { render, staticRenderFns } from "./HmTransfer.vue?vue&type=template&id=23c1a422&scoped=true&"
import script from "./HmTransfer.vue?vue&type=script&lang=js&"
export * from "./HmTransfer.vue?vue&type=script&lang=js&"
import style0 from "./HmTransfer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HmTransfer.vue?vue&type=style&index=1&id=23c1a422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1a422",
  null
  
)

component.options.__file = "HmTransfer.vue"
export default component.exports